const getDefaultAbortControllerClass = () =>
  typeof AbortController !== 'undefined' ? AbortController : null;

const createSafeAbortController = (
  AbortControllerClass = getDefaultAbortControllerClass()
) => {
  if (typeof AbortControllerClass !== 'function') {
    return null;
  }

  try {
    return new AbortControllerClass();
  } catch (_) {
    return null;
  }
};

const abortSafeController = (controller = null) => {
  if (typeof controller?.abort !== 'function') {
    return false;
  }

  try {
    controller.abort();
    return true;
  } catch (_) {
    return false;
  }
};

const getSafeAbortSignal = (controller = null) => controller?.signal;

export { abortSafeController, createSafeAbortController, getSafeAbortSignal };
